<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  canDownload: { type: Boolean, default: false },
  downloading: { type: Boolean, default: false },
  sentAt: { type: String, default: '' },
});

const emit = defineEmits(['download']);
const { t } = useI18n();
const sentLabel = computed(() => {
  if (!props.sentAt)
    return t('REAL_ESTATE_COMMISSION_INSTALLMENT.PREVIEW.NOT_SENT');

  const date = new Date(props.sentAt);
  if (Number.isNaN(date.getTime())) return props.sentAt;
  return new Intl.DateTimeFormat('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  }).format(date);
});
</script>

<template>
  <div class="flex min-w-48 flex-col items-start gap-1">
    <LaisPrimaryButton
      variant="ghost"
      icon="i-lucide-file-down"
      :disabled="!canDownload"
      :is-loading="downloading"
      @click="emit('download')"
    >
      {{ t('REAL_ESTATE_COMMISSION_INSTALLMENT.ACTIONS.DOWNLOAD') }}
    </LaisPrimaryButton>
    <p class="px-2 text-xs text-lais-text-muted">{{ sentLabel }}</p>
  </div>
</template>
